import {HorizontalLine, Stack, TextField, Text, Button} from "@mbank-design/design-system/components";
import {Speaker} from "../../../model/SpeakerInvitationCreateMessage";
import React, {useContext} from "react";
import './SpeakerSection.css';
import {SpeakersContext} from "./SpeakersContext";
import {ValidationContext} from "../SpeakerInvitationValidation";

interface SpeakerProps {
    speaker: Speaker,
    validateForm: (() => void)
}

export default function SpeakerSection({speaker, validateForm}: SpeakerProps) {
    const { onSpeakerChange, onSpeakerRemove } = useContext(SpeakersContext);
    const validationState = useContext(ValidationContext);
    
    const onInputChange = (speaker: Speaker) => {
        if (onSpeakerChange !== undefined)
            onSpeakerChange(speaker);

        validateForm();
    }
    
    const onBlur = (e: any) => {
        validateForm();
    };
    
    const validationResult = validationState.invalidSpeakers.find(s => s.uiId === speaker.uiId);
    
    return(
        <Stack>
            <div className={"speaker-section-person-header"}>
                <Text as={"small"} color={"doveGrayUI"} >attendee {speaker.uiId + 1}</Text>
                <Button buttonType={"tertiary"} onClick={() => onSpeakerRemove!(speaker.uiId)}><Text as={"small"}>clear</Text></Button>
            </div>
            <HorizontalLine />
            <TextField value={speaker.firstName} onBlur={onBlur} errorMessage={validationResult && validationResult.firstNameValidationMessage} onChange={(e) => onInputChange({...speaker, firstName: e.target.value })} label="first name" />
            <TextField value={speaker.lastName} onBlur={onBlur}  errorMessage={validationResult && validationResult.lastNameValidationMessage} onChange={(e) => onInputChange({...speaker, lastName: e.target.value })} label="last name" />
            <TextField value={speaker.email} onBlur={onBlur} errorMessage={validationResult && validationResult.emailValidationMessage} onChange={(e) => onInputChange({...speaker, email: e.target.value })} label="e-mail address" />
        </Stack>
    )
}